import { listBeats } from './beatsService'
import { listSongs } from './songsService'

// No artists endpoint in the backend yet — keep local data.
const ARTISTS = [
  { id: 'prof', name: 'Prof De Beats', role: 'Producer & Mix Engineer', image: 'https://picsum.photos/seed/artist1/400/400', bio: 'Award-winning producer with over a decade of experience crafting hits across genres from Afrobeats to Hip-Hop.', works: ['10+ Albums', 'Grammy Nominee', 'Afrobeats'] },
  { id: 'lyrik', name: 'Lyrik', role: 'Vocalist & Songwriter', image: 'https://picsum.photos/seed/artist2/400/400', bio: 'Soulful vocalist and prolific songwriter blending R&B melodies with conscious lyricism.', works: ['R&B', 'Songwriter', '50+ Features'] },
  { id: 'djvolta', name: 'DJ Volta', role: 'DJ & Sound Designer', image: 'https://picsum.photos/seed/artist3/400/400', bio: 'Creative sound designer and DJ pushing the boundaries of electronic and dance music.', works: ['EDM', 'Sound Design', 'Live Sets'] },
  { id: 'gracenotes', name: 'Grace Notes', role: 'Gospel Artist', image: 'https://picsum.photos/seed/artist4/400/400', bio: 'Uplifting gospel artist inspiring audiences with powerful vocal performances and heartfelt compositions.', works: ['Gospel', '3 Albums', 'Choir Director'] },
  { id: 'muzi', name: 'MUZI', role: 'R&B Artist & Producer', image: 'https://picsum.photos/seed/artist5/400/400', bio: 'Smooth R&B artist and self-producing talent known for late-night vibes and silky vocal layering.', works: ['R&B', 'Self-Produced', '2 EPs'] },
  { id: 'kevibe', name: 'KE Vibe', role: 'Afrobeats Artist', image: 'https://picsum.photos/seed/artist6/400/400', bio: 'East African Afrobeats sensation blending Gengetone rhythms with modern pop sensibilities.', works: ['Afrobeats', 'Gengetone', '1M+ Streams'] }
]

export function fetchBeats (params) {
  return listBeats(params)
}

export function fetchShowcaseSongs (params) {
  return listSongs(params).then(function (result) {
    return result.items
  })
}

export function fetchArtists () {
  return Promise.resolve(ARTISTS.slice())
}
